// extracted by mini-css-extract-plugin
export default {"main":"ContactModal_main__tkN78","title":"ContactModal_title__PYeT0","iconGroup":"ContactModal_iconGroup__suFj5","icons":"ContactModal_icons__A5uWX"};